import {
  Close,
  Group,
  GroupCount,
  GroupExpand,
  GroupHeader,
  GroupLabel,
  List,
  Option,
  OptionCount,
  OptionLabel,
  Options,
  OptionsWrapper,
  Reset,
  StyledFilters,
  Title,
  Toggler,
  Wrapper,
} from '@/scenes/Gallery/Filters/styles';
import { inject, observer } from 'mobx-react';
import { IGalleryStore } from '@/stores/Gallery';
import { FC, useState } from 'react';
import Button from '@/components/UI/Button';
import Badge from '@/components/Badge';

interface GalleryFiltersProps {
  galleryStore: IGalleryStore;
}

const GalleryFilters: FC<any> = ({ galleryStore }: GalleryFiltersProps) => {
  const [opened, setOpened] = useState<boolean>(false);

  const {
    filters,
    toggleFilterGroup,
    toggleFilter,
    activeFilters,
    resetFilters,
  } = galleryStore;

  const open = () => {
    document.body.style.overflow = 'hidden';
    setOpened(true);
  };

  const close = () => {
    document.body.style.overflow = 'visible';
    setOpened(false);
  };

  const reset = () => {
    resetFilters();
    close();
  };

  return (
    <StyledFilters>
      <Toggler onClick={open}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 18.2765C10 18.8518 10.4664 19.3182 11.0417 19.3182H12.9583C13.5336 19.3182 14 18.8518 14 18.2765C14 17.7012 13.5336 17.2348 12.9583 17.2348H11.0417C10.4664 17.2348 10 17.7012 10 18.2765ZM4.04167 6.25C3.46637 6.25 3 6.71637 3 7.29167C3 7.86696 3.46637 8.33333 4.04167 8.33333H19.9583C20.5336 8.33333 21 7.86696 21 7.29167C21 6.71637 20.5336 6.25 19.9583 6.25H4.04167ZM6 12.7841C6 13.3594 6.46637 13.8258 7.04167 13.8258H16.9583C17.5336 13.8258 18 13.3594 18 12.7841C18 12.2088 17.5336 11.7424 16.9583 11.7424H7.04167C6.46637 11.7424 6 12.2088 6 12.7841Z"
          />
        </svg>
      </Toggler>
      <Wrapper opened={opened}>
        <Close onClick={close} />
        <Title>Filters</Title>
        <List>
          {filters.map((group, groupIndex) => (
            <Group
              key={group.type}
              expanded={group.expanded}
              last={groupIndex === filters.length - 1}
            >
              <GroupHeader onClick={() => toggleFilterGroup(group)}>
                <GroupLabel>{group.type}</GroupLabel>
                {activeFilters.findIndex((g) => g.type === group.type) !==
                  -1 && (
                  <GroupCount>
                    <Badge secondary>
                      {
                        activeFilters
                          .find((g) => g.type === group.type)
                          .options.filter((o) => o.active).length
                      }
                    </Badge>
                  </GroupCount>
                )}
                <GroupExpand>
                  <svg
                    width="6"
                    height="3"
                    viewBox="0 0 6 3"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 2.83333L0.61843 0.0833278L5.38157 0.0833282L3 2.83333Z"
                      fill="white"
                    />
                  </svg>
                </GroupExpand>
              </GroupHeader>
              <OptionsWrapper>
                <Options>
                  {group.options.map((option) => (
                    <Option
                      active={option.active}
                      key={option.value}
                      onClick={() => {
                        if (!option.active) toggleFilter(group, option, true);
                      }}
                    >
                      <OptionLabel>{option.value}</OptionLabel>
                      <OptionCount>{option.total}</OptionCount>
                    </Option>
                  ))}
                </Options>
              </OptionsWrapper>
            </Group>
          ))}
          <Reset>
            <Button type="secondary" colored onClick={reset}>
              Reset Filters
            </Button>
          </Reset>
        </List>
      </Wrapper>
    </StyledFilters>
  );
};

export default inject('galleryStore')(observer(GalleryFilters));
